<template>
  <v-expansion-panel-header disable-icon-rotate :expand-icon="!isExpanded && canEditOffer ? 'mdi-pencil' : null"
    :class="isExpanded ? 'mb-0 pb-0' : canEditOffer ? '' : 'readonly'" data-cy="add-serv-header">
    <div class="d-flex justify-space-between">
      <div class="d-flex flex-column justify-center">
        <p class="mb-1 text-body-2 panel__description">
          {{ $t(service.desc_key) }}
        </p>
      </div>
      <v-fade-transition hide-on-leave>
        <p v-if="isExpanded" class="mb-2 mr-12 text-body-2 grey-font panel__description px-8">
          {{ $t('ADDITIONAL_SERV_EDITION_DESCRIPTION') }}
        </p>
      </v-fade-transition>

      <!-- Precios del header -->
      <div v-if="!isExpanded" class="d-flex panel__price">
        <div class="d-flex flex-column mx-8">
          <template
            v-if=" service.value === 0">
            <p class="mb-1 text-body-2">
              {{ $t('NOT_INCLUDED') }}
            </p>
          </template>
          <template v-else>
            <p class="mb-1 text-body-2" data-cy="add-serv-header-value">
              {{ valueLabel[service.type] }}
            </p>
            <p v-if="service.type === 'LIST-VALUES'" class="mb-2 text-body-2">
              {{ service.selected ? $t(service.selected) : '------' }}
            </p>
            <p v-else class="mb-2 text-body-2">
              {{ formatValue(service.value) }}
              <span>{{ suffix(service.type) }}</span>
            </p>
          </template>
        </div>
        <template v-if="service.type === 'PERCENTAGE'">
          <div class="d-flex flex-column mx-8">
            <template v-if="service.minValue > 0">
              <p class="mb-1 text-body-2">
                {{ $t('ADDITIONAL_SERV_FIELD_MIN') }}
              </p>
              <p class="mb-2 text-body-2" data-cy="add-serv-header-min-value">
                {{ formatValue(service.minValue) }}
                <span v-if="!isValueEmpty(service.minValue)">&#8364;</span>
              </p>
            </template>
          </div>
          <div class="d-flex flex-column mx-8">
            <template v-if="service.maxValue > 0">
              <p class="mb-1 text-body-2">
                {{ $t('ADDITIONAL_SERV_FIELD_MAX') }}
              </p>
              <p class="mb-2 text-body-2" data-cy="add-serv-header-max-value">
                {{ formatValue(service.maxValue) }}
                <span v-if="!isValueEmpty(service.maxValue)">&#8364;</span>
              </p>
            </template>
          </div>
          <div class="d-flex flex-column mx-8">
            <template v-if="service.canExpire">
              <p class="mb-1 text-body-2">
                {{ $t('ADDITIONAL_SERV_FIELD_EXPIRE_MONTHS') }}
              </p>
              <p class="mb-2 text-body-2" data-cy="add-serv-header-max-value">
                {{ formatMonths(service.expireMonths) }}
              </p>
            </template>
          </div>
        </template>
      </div>
      <!-- Precios del header -->
    </div>
  </v-expansion-panel-header>
</template>

<script>
import { mapGetters } from 'vuex';
import { numberOperations } from '@/helpers/helpers';

export default {
  name: 'PanelHeader',
  props: {
    isExpanded: { type: Boolean, default: false },
    service: {
      type: Object,
      default: function () {
        return {
          value: 0,
          minValue: 0,
          maxValue: 0,
          desc_key: '',
          selected: null,
          listValues: [],
          type: '',
          id: '',
        };
      },
    },
  },
  data() {
    return {
      valueLabel: {
        'LIST-VALUES': this.$t('ADDITIONAL_SERV_FIELD_SELECT'),
        PERCENTAGE: this.$t('ADDITIONAL_SERV_FIELD_PERCENTAGE'),
        AMOUNT: this.$t('ADDITIONAL_SERV_FIELD_PRICE'),
      },
    };
  },
  computed: {
    ...mapGetters('offer', ['canEditOffer']),
  },
  methods: {
    suffix(type) {
      return type === 'PERCENTAGE' ? '%' : type === 'AMOUNT' ? '€' : '';
    },
    isValueEmpty(value) {
      return value === null || value === '';
    },
    formatValue(num) {
      if (num === null || num === '') {
        return '-';
      }
      const roundedNum = numberOperations.roundNumber(num, 2);
      const formattedNum = roundedNum.toFixed(2).replace('.', ',');

      return formattedNum;
    },
    formatMonths(num) {
      return num === null || num === '' || num === 0
        ? '-'
        : num;
    }
  }
}
</script>


<style scoped lang="scss">
.panel {
  @media (min-width: 1080px) {
    &__price {
      width: 55%;
    }

    &__description {
      width: rem(280);
    }
  }
}

.v-expansion-panel-header.readonly {
  cursor: initial;
}
</style>
